// constants
const SET_ROLE = "SET_ROLE";

// actions
export const setRole = (payload) => ({
  type: SET_ROLE,
  payload,
});

// reducer
const initialState = {
  role: ""
};

const reducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case SET_ROLE:
      return {
        ...state,
        ...payload,
      };
    default:
      return state;
  }
};

export default reducer;
